import { render, staticRenderFns } from "./TeachTableSelectorByClass.vue?vue&type=template&id=36d3cf23"
import script from "./TeachTableSelectorByClass.vue?vue&type=script&lang=js"
export * from "./TeachTableSelectorByClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports